import React, { useEffect } from "react"
import { inject } from "mobx-react";
import { useForm } from "react-hook-form";
import { Redirect } from "react-router-dom";
import logo from "../Style/logo.webp";
import config from "../config";

const Auth = ( props ) => {

	const {register, handleSubmit, errors} = useForm();

	useEffect( () => {

		document.title = config.title;

		if( props.Auth.token ){
			return <Redirect to="/"/>
		}


	}, [props])

	const onSubmit = async ( data ) => {

		await props.Auth.login( data )

		if (props.Auth.token) {
			return <Redirect to="/"/>
		}

	};

	return (
		<div className={"login"}>

			<div className={"login-content"}>
				<div className={"login-logo-container"}>
					<img src={logo} alt="logo" className={"login-logo"}/>
				</div>
				<h1 className={"login-title text-center"}>Logowanie</h1>
				<p className={"text-muted text-center"}>System Zarządzanie Zamówieniami</p>
				<div>
					{props.Auth.error &&
					<p className={"form-validate text-center"}>Błędny login bądź hasło</p>}
					<form onSubmit={handleSubmit( onSubmit )} autoComplete={"off"}>
						<div className={"form-group"}>
							<label className={"form-label"}>Login</label>
							<input type="text" className={"form-control"} name={"email"}
							       ref={register( {required: true} )}/>
							{errors.email && <span className={"form-validate"}>Pole wymagane</span>}
							{props.Auth.error.email && <span className={"form-validate"}>{props.Auth.error.email}</span>}
						</div>
						<div className={"form-group"}>
							<label className={"form-label"}>Hasło</label>
							<input type="password" className={"form-control"} name={"password"}
							       ref={register( {required: true} )} autoComplete="off" />
							{errors.password && <span className={"form-validate"}>Pole wymagane</span>}
							{props.Auth.error.password && <span className={"form-validate"}>{props.Auth.error.password}</span>}
						</div>
						<button type={"submit"} className={"btn btn--primary"}>
							{
								props.Auth.loading ? `Przetwarzanie` : `Zaloguj się`
							}
						</button>
					</form>
					<div className="" style={{textAlign:"center",margin:"15px 0"}}>
						<small>{ config.version }</small>
					</div>
				</div>
			</div>
		</div>
	);
}

export default inject( 'Auth' )( (Auth) )
